export default __webpack_public_path__ + "locales/ru/About.json?hash=337572ca36e8b628420165a72ad129d6";